import request from "@/utils/request";

const me = () => request
  .get("/api/organisations/me");

export default {
  me
};
